export default "__VITE_ASSET__Cd68tD2Z__"